import { getCommonConfigKey, orderPay } from "@/api";
import { formatTime } from "@/libs/filter";
import { PAY_TYPE } from "@/libs/config";
import {urlSchemeGenerate} from "@a/invitation.js";
/*
* 金额的转换(分)
* */
export const priceYuan = (val, w = 2) => {
    if (val) {
      return  (Number(val) / 100).toFixed(w)
    }
    return '-'
 }




/** lawsuitShare.7.0获取系统配置的服务时间 案源付费默认有效时间(秒) 7天 */
export const getServiceCasePaySetTime = () => {
  return new Promise((resolve) => {
    getCommonConfigKey({ paramName: 'case_source_v2_pay_valid_time' }).then( ({ data }) => {
      if(data){
        resolve (formatTime(data.paramValue))
      }else{
        resolve( '7天')
      }
    })
  })
}

/*微信内部支付*/
// export const weiXinPay = () => {
//   function onBridgeReady() {
//     WeixinJSBridge.invoke(
//       "getBrandWCPayRequest",
//       {
//         appId: "wx2421b1c4370ec43b", //公众号ID，由商户传入
//         timeStamp: "1395712654", //时间戳，自1970年以来的秒数
//         nonceStr: "e61463f8efa94090b1f366cccfbbb444", //随机串
//         package: "prepay_id=u802345jgfjsdfgsdg888",
//         signType: "MD5", //微信签名方式：
//         paySign: "70EA570631E4BB79628FBCA90534C63FF7FADD89", //微信签名
//       },
//       function(res) {
//         if (res.err_msg == "get_brand_wcpay_request:ok") {
//           // 使用以上方式判断前端返回,微信团队郑重提示：
//           //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
//         }
//       }
//     );
//   }

//   if (typeof WeixinJSBridge == "undefined") {
//     if (document.addEventListener) {
//       document.addEventListener("WeixinJSBridgeReady", onBridgeReady, false);
//     } else if (document.attachEvent) {
//       document.attachEvent("WeixinJSBridgeReady", onBridgeReady);
//       document.attachEvent("onWeixinJSBridgeReady", onBridgeReady);
//     }
//   } else {
//     onBridgeReady();
//   }
// };

/*当前月份第一天：*/
export const getMonthFirstDay = () =>{
    var date = new Date();
    date.setDate(1);
    var month = parseInt(date.getMonth()+1);
    var day = date.getDate();
    if (month < 10) {
        month = '0' + month
    }
    if (day < 10) {
        day = '0' + day
    }
    return  month + '.' + day
}

/*当前月份最后一天*/
export const getMonthLastDay = () =>{
    var endDate=new Date();
    var currentMonth=endDate.getMonth();
    var nextMonth=++currentMonth;
    var nextMonthFirstDay=new Date(endDate.getFullYear(),nextMonth,1);
    var oneDay=1000*60*60*24;
    var lastTime = new Date(nextMonthFirstDay-oneDay);
    var endMonth = parseInt(lastTime.getMonth()+1);
    var endDay = lastTime.getDate();
    if (endMonth < 10) {
        endMonth = '0' + endMonth
    }
    if (endDay < 10) {
        endDay = '0' + endDay
    }
    return endMonth + '.' + endDay
}
/**
 * @description: 支付
 * @author:djsong
 * @date:2022/5/9
 * @param: params:{orderId:Number,payType:Number}
 * @return: Promise
*/
export const toPay = (params) => {
  /* 支付 */
  return orderPay({
    orderId: params.orderId,
    payType: params.payType
  }).then(({ data }) => {
    if(!data.free){
      if (PAY_TYPE.ALIPAY === params.payType) {
        document.body.insertAdjacentHTML('beforeend', data.payResultMsg)
        setTimeout(() => {
          document.getElementsByName('punchout_form')[0].submit()
        })
      } else {
        const payResultMsg = JSON.parse(data.payResultMsg)
        let h5Url = payResultMsg.h5_url
        console.log('h5Url:', h5Url)
        if (params.payType === PAY_TYPE.HUIPAY) {
          const redirectUrl = params.redirectPath ? params.redirectPath : '/confirm-order/pay-loading'
          setTimeout(() => {
            window.location.href = window.location.origin + '/#' + redirectUrl + `?outTradeNo=${data.orderNo}&orderId=${data.orderId}&v=${Date.now()}`
            // window.location.href = window.location.origin + redirectUrl + `?outTradeNo=${data.orderNo}&orderId=${data.orderId}&v=${Date.now()}`
          }, 5000)
          h5Url = `alipays://platformapi/startapp?saId=10000007&qrcode=${h5Url}`
          // window.location.href = data.payResultMsg.h5_url
        // eslint-disable-next-line no-empty
        } else {
        }
        window.location.href = h5Url
      }
    }else{
      this.$toast('此订单免费！')
    }
    return data
  })
}

export const creatScript = (src) =>{
    var s = document.getElementsByTagName('script')[0]
    var hm = document.createElement('script')
    hm.src = src
    s.parentNode.insertBefore(hm, s)
}

export const creatAppletsScript = ()=>{
    var userAgent = navigator.userAgent;
    if (userAgent.indexOf('AlipayClient') > -1) {
        // 支付宝小程序的 JS-SDK 防止 404 需要动态加载，如果不需要兼容支付宝小程序，则无需引用此 JS 文件。
        creatScript('https://appx/web-view.min.js')
    } else if (/QQ/i.test(userAgent) && /miniProgram/i.test(userAgent)) {
        // QQ 小程序
        creatScript('https://qqq.gtimg.cn/miniprogram/webview_jssdk/qqjssdk-1.0.0.js')
    } else if (/miniProgram/i.test(userAgent) && /micromessenger/i.test(userAgent)) {
        // 微信小程序 JS-SDK 如果不需要兼容微信小程序，则无需引用此 JS 文件。
        creatScript('https://res.wx.qq.com/open/js/jweixin-1.4.0.js')
    } else if (/toutiaomicroapp/i.test(userAgent)) {
        // 头条小程序 JS-SDK 如果不需要兼容头条小程序，则无需引用此 JS 文件。
        creatScript('https://s3.pstatp.com/toutiao/tmajssdk/jssdk-1.0.1.js')
    } else if (/swan/i.test(userAgent)) {
        // 百度小程序 JS-SDK 如果不需要兼容百度小程序，则无需引用此 JS 文件。
        creatScript('https://b.bdstatic.com/searchbox/icms/searchbox/js/swan-2.0.18.js')
    } else if (/quickapp/i.test(userAgent)) {
        // quickapp
        creatScript('https://quickapp/jssdk.webview.min.js')
    }

/*    if (!/toutiaomicroapp/i.test(userAgent)) {
        document.querySelector('.post-message-section').style.visibility = 'visible';
    }*/
    creatScript('https://unpkg.com/@dcloudio/uni-webview-js@0.0.3/index.js')
}

/* base64 下载图片*/
export const downloadPic = (imgUrl) => {
    // 如果浏览器支持msSaveOrOpenBlob方法（也就是使用IE浏览器的时候），那么调用该方法去下载图片
    if (window.navigator.msSaveOrOpenBlob) {
        const bstr = atob(imgUrl.split(',')[1])
        let n = bstr.length
        const u8arr = new Uint8Array(n)
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n)
        }
        const blob = new Blob([u8arr])
        window.navigator.msSaveOrOpenBlob(blob, 'chart-download' + '.' + 'png')
    } else {
        // 这里就按照chrome等新版浏览器来处理
        const a = document.createElement('a')
        a.href = imgUrl
        a.setAttribute('download', 'chart-download.png')
        a.click()
    }
}

/*唤醒微信小程序*/
export const    wakeUpWeChatApplets = (params={path:"",query:""}) => {
    const URLScheme = sessionStorage.getItem('URLScheme_2')
    if (URLScheme) {
        window.location.href = URLScheme
        return false
    }
    urlSchemeGenerate(params).then(({data}) => {
        sessionStorage.setItem('URLScheme_2', data)
        window.location.href = data
    })
}
